<template>
  <!-- 档案流程详情 -->
  <div class="details-box">
    <div class="title">
      归档资料借阅进度（ {{details.Code}} ）
    </div>
    <div v-if="JSON.stringify(details) != '{}'">
      <sub-title title="资料信息"></sub-title>
      <div class="details-table">
        <div class="details-box-item">
          <div class="item-left">
            申请文件：
          </div>
          <div class="item-right">
            <span v-for="(item,i) in details.FileNameList && details.FileNameList.split(',')" :key="i">
              <span>{{item}}</span>
              <span v-if="!(i===details.FileNameList.split(',').length-1)">、</span>
            </span>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">
              企业名称：
            </div>
            <div class="item-right">
              {{details.CompanyName}}
            </div>
          </div>
          <div class="details-box-item" style="width:66%">
            <div class="item-left">
              项目名称：
            </div>
            <div class="item-right">
              {{details.ProjectTitle}}
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">
              文件类型：
            </div>
            <div class="item-right">
              {{details.SourceName}}
            </div>
          </div>

          <div class="details-box-item">
            <div class="item-left">
              借阅类别：
            </div>
            <div class="item-right">
              {{details.BorrowCategory}}
            </div>
          </div>
          <div class="details-box-item">
            <div class="item-left">
              借出事由：
            </div>
            <div class="item-right">
              {{details.BorrowMemo}}
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item">
            <div class="item-left">
              借出日期：
            </div>
            <div class="item-right">
              {{$common.timesToTime(details.BorrowDate)}}
            </div>
          </div>
          <div class="details-box-item" v-if="!!details.OperationPersonName">
            <div class="item-left">
              运营帮借：
            </div>
            <div class="item-right">
              {{details.OperationPersonName}}
            </div>
          </div>
          <div class="details-box-item" v-if="!!details.BusinessPersonName">
            <div class="item-left">
              业务员姓名：
            </div>
            <div class="item-right">
              {{details.BusinessPersonName}}
            </div>
          </div>
        </div>
        <div class="details-box-item">
          <div class="details-box-item" v-if="details.BorrowCategory === '带出借阅'">
            <div class="item-left">
              归还日期：
            </div>
            <div class="item-right">
              {{$common.timesToTime(details.ReturnDate)}}
            </div>
          </div>
          <div class="details-box-item" style="width:66%" v-if="details.BorrowCategory === '其它'">
            <div class="item-left">
              备注：
            </div>
            <div class="item-right">
              {{details.BorrowRemark}}
            </div>
          </div>
        </div>
      </div>
      <!-- 流程图 -->
      <flow-chart :details="details" :selTab="type" :TemplateID="TemplateID" @close="$emit('refresh')" v-if="JSON.stringify(details)!='{}'">
        <div slot="user-defined" style="text-align: center;" v-if="details.Status === 2">
          <el-button type="primary" size="medium" v-if="/Admin|DataAdministrator/gi.test(userInfo.Role)" @click="createLink">设置下载有效期</el-button>
          <el-button type="primary" size="medium" v-if="details.ApplyUserID === userInfo.UserId || userInfo.Role === 'Admin'" :disabled="limit" :loading="downloadLoad" @click="downloadFile">{{downloadFileBtnText}}</el-button>
        </div>
      </flow-chart>
    </div>
  </div>
</template>
<script>
import { WorkflowQuery, ArchivedBorrowing } from "@/http/api";

export default {
  name: "ArchivesProcessDetail",
  components: {},
  props: {
    ID: {       // 当前id
      type: Number,
      default: null
    },
    type: {
      type: String,
      default: ""
    },
    TemplateID: {    // 流程ID
      type: Number,
      default: null
    }
  },
  watch: {
    ID: {
      handler(val, oldVal) {
        this.getDetails();
      },
      immediate: true
    }
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo') || "{}"),
      passLoad: false,
      rejectedLoad: false,
      details: {},
      limit: false,
      downloadLoad: false,
      downloadFileBtnText: '下载文件'
    };
  },
  methods: {
    validation(time) {
      const DownloadDeadline = time ? new Date(time).getTime() : null;
      const now = Date.parse(new Date());
      return DownloadDeadline ? DownloadDeadline < now : true;
    },
    getDetails() {
      this.$emit('loading', true)
      WorkflowQuery({ workflowId: this.ID, templateId: this.TemplateID }, 'Get').then(res => {
        if (!!res && JSON.stringify(res) != "{}") this.details = res;
        this.limit = this.validation(res.DownloadDeadline);
        this.downloadFileBtnText = this.validation(res.DownloadDeadline) ? '文件已过有效期' : '下载文件';
        this.$emit('loading', false)
      })
    },
    createLink() {
      this.$prompt('请输入下载有效期（分钟）', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\d+/,
        inputErrorMessage: '时间格式不正确',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            const nowTime = new Date().getTime();
            const limitTime = instance.inputValue * 60 * 1000;
            const model = { DownloadDeadline: this.$common.timesToTime(nowTime + limitTime, true), ID: this.details.ID };
            ArchivedBorrowing({ model }, 'Update').then(res => {
              this.getDetails();
              this.$message({ message: res ? '设置成功！' : '设置失败！', type: res ? 'success' : 'error' });
            }).finally(() => {
              done();
              instance.confirmButtonLoading = false;
            })
          } else {
            done();
          }
        },
      })
    },
    downloadFile() {
      this.downloadLoad = true;
      let fileId = this.details.FileList;
      this.$parallelDownload(fileId, () => {
        this.downloadLoad = false;
        this.downloadFileBtnText = "下载文件";
      }, (progress) => {
        this.downloadFileBtnText = `下载进度：${progress}`;
      })
    }
  }
};

</script>
<style scoped lang='less'>
@import "./details.less";
</style>